import axios from '../api'
const URL = 'eos/coupon/group/'
const getAllMember = params => {
  console.log(params)
  return axios({
    url: `${URL}getAllMember`,
    params
  })
}
const createGroupMember = params => {
  console.log(params)
  return axios({
    url: `${URL}createGroupMember`,
    method: 'post',
    data: params
  })
}
const removeGroupMember = params => {
  return axios({
    url: `${URL}removeGroupMember`,
    params
  })
}
const getGroupInfoForHomePage = params => {
  return axios({
    url: `${URL}getGroupInfoForHomePage`,
    params
  })
}
export default {
  getAllMember,
  createGroupMember,
  removeGroupMember,
  getGroupInfoForHomePage
}
